import { createContext, useContext } from "react";
import type { Product, Lang, Translations } from "./types";

export interface CtxShape {
  addCart: (p: Product) => void;
  togFav: (id: Product["id"]) => void;
  favs: Array<Product["id"]>;
  lang: Lang;
  t: Translations;
  $: (n: number) => string;
  setCmpIds: (fn: (prev: Array<Product["id"]>) => Array<Product["id"]>) => void;
  cmpIds: Array<Product["id"]>;
  toast: (msg: string) => void;
  setQuickView: (p: Product | null) => void;
}

export const Ctx = createContext<CtxShape | null>(null);

export function useCtx(): CtxShape {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error("useCtx must be used inside Ctx.Provider");
  return ctx;
}
